<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Pinia Store
const componentsStore = useComponentsStore()

// Computed Properties
const tableName = computed(() => viewStore.tableName)

const component = computed(() => {
    if (!tableName.value) return undefined
    return componentsStore.items.find(obj => obj.tableName === tableName.value)
})

const hasThumbnailColumn = computed(() => {
    if (tableName.value === 'files') return true
    return !!(component.value && component.value.thumbnailColumn)
})

const viewMode = computed(() => viewStore.viewMode || 'table')

// Methods
const changeView = () => {
    const targetMode = viewMode.value === 'thumbnail' ? 'table' : 'thumbnail'
    viewStore.setViewMode(targetMode)
}
</script>

<template>
    <button v-if="hasThumbnailColumn" class="d-flex align-items-center" type="button" @click="changeView">
        <i
            :class="{'bi-grid-3x3-gap-fill': viewMode === 'table', 'bi-list': viewMode === 'thumbnail'}"
            class="me-2"
        />
        {{ viewMode === 'thumbnail' ? 'List' : 'Thumbnail' }} view
    </button>
</template>